/**
 * Recuperação de itens presos em processing.
 */

import type { QueueItem } from '../queue';
import { isProcessingTimedOut, PROCESSING_TIMEOUT_MS } from '../queue/stateMachine';
import { recordOrphanProcessing } from '../telemetry';

export function recoverStuckProcessingItems(
  items: QueueItem[],
  now: number,
  timeoutMs = PROCESSING_TIMEOUT_MS
): number {
  let recovered = 0;
  for (const item of items) {
    if (item.status !== 'processing') continue;
    const stuckAt = item.processingAt ?? item.createdAt;
    if (isProcessingTimedOut(stuckAt, now, timeoutMs)) {
      item.status = 'queued';
      delete item.processingAt;
      recordOrphanProcessing(1);
      recovered++;
    }
  }
  return recovered;
}
